/**
 * Updates a measures array by grouping properties by their first letter.
 *
 * @param {Array<Object>} measuresArray - The array to update with the new measure
 * @param {string} key - The property key to process
 * @param {*} value - The value to store under the processed key
 */

const updateMeasureArray = (measuresArray, key, value) => {
  const firstKeyLetter = key[0]
  const updatedKey = key.slice(1).toLowerCase()
  const recordIndex = measuresArray.findIndex(
    measure => measure.letter === firstKeyLetter
  )

  if (recordIndex === -1) {
    measuresArray.push({letter: firstKeyLetter, [updatedKey]: value})
  } else {
    measuresArray[recordIndex] = {
      ...measuresArray[recordIndex],
      [updatedKey]: value
    }
  }
}

const filterMeasuresWithNoId = measuresArray => {
  const filteredMeasures = measuresArray.filter(measure => !!measure.measureid)

  return filteredMeasures
}

/**
 * Formats measure data by grouping properties by their first letter into measure arrays.
 * This should no longer be necessary once the backend is updated to return the data in this format
 *
 * @param {Array<Object>} measures - Array of measure objects to be formatted
 *
 * @returns {Array<Object>|undefined} - Formatted measures array with properties grouped by first letter,
 *                                      or undefined if no measures provided
 */

export const temporaryFormatMeasures = measures => {
  if (!measures) return

  const formattedMeasures = measures.map(measure => {
    const {
      productId,
      productMeasureId,
      productWidth,
      productWidthId,
      size,
      sizeId,
      ...rest
    } = measure

    const measuresArray = []

    for (const [key, value] of Object.entries(rest)) {
      updateMeasureArray(measuresArray, key, value)
    }

    return {
      productId,
      productMeasureId,
      productWidth,
      productWidthId,
      size,
      sizeId,
      measuresArray: filterMeasuresWithNoId(measuresArray)
    }
  })

  return {measures: formattedMeasures}
}
